import { useNavigate as useNavigateHook } from 'react-router-dom'

export { useNavigate }

type Navigate = {
  (to: string, options?: { replace?: boolean }): void
  (to: number): void
}

const useNavigate = (): Navigate => {
  const navigateFn = useNavigateHook()

  const navigate: Navigate = (
    to: string | number,
    options?: { replace?: boolean },
  ) => {
    if (typeof to === 'number') {
      return navigateFn(to)
    } else {
      return navigateFn(to, { replace: options?.replace })
    }
  }

  return navigate
}
